import React from 'react';

interface IProps {
    value: string;
    onValueChange: (value: string) => void;
    onSubmit: () => void | Promise<void>;
    placeholder: string;
    ariaLabel: string;
    buttonLabel: string;
    loading?: boolean;
    loadingLabel?: string;
    error?: string | null;
    inputMode?: 'none' | 'text' | 'tel' | 'url' | 'email' | 'numeric' | 'decimal' | 'search';
}

const DirectLookup: React.FC<IProps> = ({
    value,
    onValueChange,
    onSubmit,
    placeholder,
    ariaLabel,
    buttonLabel,
    loading = false,
    loadingLabel = 'Opening...',
    error,
    inputMode = 'text',
}) => {
    const canSubmit = value.trim().length > 0 && !loading;

    return (
        <div role="search" aria-label={ariaLabel} style={styles.wrapper}>
            <input
                type="text"
                inputMode={inputMode}
                aria-label={ariaLabel}
                placeholder={placeholder}
                value={value}
                onChange={(event) => onValueChange(event.target.value)}
                onKeyDown={(event) => {
                    if (event.key === 'Enter' && canSubmit) {
                        onSubmit();
                    }
                }}
                disabled={loading}
                style={{ ...styles.input, borderColor: error ? '#EF4444' : '#D1D5DB' }}
            />
            <button
                type="button"
                onClick={onSubmit}
                disabled={!canSubmit}
                style={{ ...styles.button, opacity: canSubmit ? 1 : 0.55, cursor: canSubmit ? 'pointer' : 'not-allowed' }}
            >
                {loading ? loadingLabel : buttonLabel}
            </button>
            {error && (
                <span role="alert" style={styles.error}>
                    {error}
                </span>
            )}
        </div>
    );
};

const styles: { [key: string]: React.CSSProperties } = {
    wrapper: {
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '0.4rem',
        padding: '0.25rem',
        border: '1px solid #E5E7EB',
        borderRadius: '8px',
        backgroundColor: '#FFFFFF',
    },
    input: {
        width: '150px',
        height: '34px',
        boxSizing: 'border-box',
        padding: '0 0.65rem',
        border: '1px solid #D1D5DB',
        borderRadius: '6px',
        color: '#111827',
        backgroundColor: '#FFFFFF',
        fontSize: '0.875rem',
    },
    button: {
        height: '34px',
        padding: '0 0.75rem',
        border: '1px solid #D1D5DB',
        borderRadius: '6px',
        color: '#374151',
        backgroundColor: '#F3F4F6',
        fontSize: '0.875rem',
        fontWeight: 600,
        whiteSpace: 'nowrap',
    },
    error: {
        position: 'absolute',
        top: 'calc(100% + 0.25rem)',
        left: 0,
        zIndex: 10,
        minWidth: '220px',
        padding: '0.4rem 0.55rem',
        border: '1px solid rgba(239, 68, 68, 0.35)',
        borderRadius: '5px',
        color: '#B91C1C',
        backgroundColor: '#FFFFFF',
        boxShadow: '0 1px 2px rgba(0, 0, 0, 0.08)',
        fontSize: '0.8rem',
        fontWeight: 500,
        whiteSpace: 'nowrap',
    },
};

export default DirectLookup;



// WEBPACK FOOTER //
// ./src/components/common/DirectLookup.tsx